
$(window).bind("load", function(){
  if (document.readyState === "complete") {
    setTimeout(function () {
      if(document.location.pathname === "/"){
        gsap.to(".loaderwesbitewhite", 1.5, {
            delay: .2,
            top: "-130%",
            ease: Expo.easeInOut
        });
      }

//       $(".loaderwesbitewhite").fadeOut(0);
    }, 0);
    
     setTimeout(function(){
      jQuery(function($) {
        $('.counter,[data-word^=1966]').countTo({
            from: 1965,
            to: new Date().getFullYear(),
            speed: 2000,
           refreshInterval: 90,
            onComplete: function(value) {
                console.debug(this);
            }
        });
    });
   }, 1100);
    
//      gsap.from(".ls-about-banner h1 .aniamtionreveal", 1, {
//              delay: 1.2,
//              y: "100%",
//              ease: Expo.easeInOut
//      })
    
    
  /*  gsap.from(".site-header", .5, {
      //delay: 1,
            opacity: 0,
            y: -100,
            ease: Expo.easeInOut
          })*/
    $(".ls-banner-img").addClass("active");
  
    /* AOS */
    AOS.init({
      duration: 1500,
      offset: 60,
      once: true,
    });
    
    
//     gsap.to(".first", 2, {
//             delay: .5,
//             top: "-100%",
//             ease: Expo.easeInOut
//         });

//         gsap.to(".second", 2, {
//             delay: .7,
//             top: "-100%",
//             ease: Expo.easeInOut
//         });
     
}
//   $('.product-recommendations ').attr('data-aos','fade-in')
});


 $('.jarallax').jarallax({
        speed: .5
  });

$('.ls-home-banner,.ls-home-built,.ls-section-leiter-s-offers .feature-row,.section-shop-col .shop-block-handle ,.shopify-section.index-section,.ls-home-built-icon, .ls-home-built-icon .feature-row, .index-section.cust_html ,.ls-feature--section.ls-feature-right, .ls-section-nationwide-delivery, .grid-item-sukkah.grid--collection ,.grid__item.grid-product ,.product-recommendations-placeholder, .section-shop-col2 .block-shop-title , .how-it-works-page .sukkah_click_sec,  .how-it-works-page .section-header').attr('data-aos', 'fade-in');

// $('.slideshow-wrapper.how-it-works-custom  .hero--slideshow ').removeAttr('data-aos','hero__animation');
// $('.slideshow-wrapper.how-it-works-custom  .hero--slideshow ').removeClass('aos-animate');


// $('.grid-item-sukkah .grid__item .image-wrap img,.grid-item-sukkah .grid__item .image-wrap svg').removeAttr( 'data-aos', 'fade-in');


// $('.feature-row__img' '.image-wrap').removeAttr('data-jarallax-element','80');
// $('.feature-row__img' '.image-wrap img').attr('data-jarallax-element','80');







$(".showimgg").click(function() {
  
  $(".hideimgg").fadeIn(100);
   $(this).fadeOut(100);
  
})

window.addEventListener("load", function () {
  
  let revealText = document.querySelectorAll(".reveal-text,.ls-home-built .h3,.ls-home-built-icon .h3, .index-section h2 .build-title, .ls-section-leiter-s-offers h2 ,.about-program-section h2, .ls-feature-right h2,.ls-section-nationwide-delivery .h3, .ls-home-shop h2 , .how-it-works-page .section-header h1");
  let results = Splitting({ target: revealText, by: "lines" });
  jQuery(".reveal-text,.ls-home-built .h3,.ls-home-built-icon .h3,.index-section  h2 .build-title, .ls-section-leiter-s-offers h2,.about-program-section h2, .ls-feature-right h2 ,.ls-section-nationwide-delivery .h3,.grid-item-sukkah, .ls-home-shop h2, .how-it-works-page .sukkah_click_sec h2,  .how-it-works-page .section-header h1").css("visibility", "visible");


  results.forEach((splitResult) => {
    const wrappedLines = splitResult.lines
      .map(
        (wordsArr) => `
        <span class="line"><div>
          ${wordsArr
            .map(
              (word) => `${word.outerHTML}<span class="whitespace"> 
         </span>`
            )
            .join("")}
        </div></span>`
      )
      .join("");
    splitResult.el.innerHTML = wrappedLines;
  });

  gsap.registerPlugin(ScrollTrigger);
  let revealLines = revealText.forEach((element) => {
    const lines = element.querySelectorAll(".line div");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 100%"
      }
    });
    tl.set(lines, { autoAlpha: 1 });
    tl.from(lines, 0.6, {
      yPercent: 100,
      ease: Power3.out,
      stagger: 0.1,
      delay: 0.2
    });
  });
});

// shop page banner txtanimation

window.addEventListener("load", function () {
  
  let revealText = document.querySelectorAll(".section-shop-col2 h2, .how-it-works-page .sukkah_click_sec h2 ");
  let results = Splitting({ target: revealText, by: "lines" });
  jQuery(".section-shop-col2 h2").css("visibility", "visible");
//   jQuery(".section-shop-col2 h2").attr("data-aos", "fade-in");
  


  results.forEach((splitResult) => {
    const wrappedLines = splitResult.lines
      .map(
        (wordsArr) => `
        <span class="line"><div>
          ${wordsArr
            .map(
              (word) => `${word.outerHTML}<span class="whitespace"> 
         </span>`
            )
            .join("")}
        </div></span>`
      )
      .join("");
    splitResult.el.innerHTML = wrappedLines;
  });

  gsap.registerPlugin(ScrollTrigger);
  let revealLines = revealText.forEach((element) => {
    const lines = element.querySelectorAll(".line div");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 100%"
      }
    });
    tl.set(lines, { autoAlpha: 1 });
    tl.from(lines, 1.2, {
      yPercent: 100,
      ease: Power3.out,
      stagger: 0.1,
      delay: 0.1
    });
  });
});

// about page banner txt anim

// window.addEventListener("load", function () {
  
//   let revealText = document.querySelectorAll(".ls-about-banner h1 .animationreveal");
//   let results = Splitting({ target: revealText, by: "lines" });
//   jQuery(".ls-about-banner h1 .animationreveal").css("visibility", "visible");
// //   jQuery(".section-shop-col2 h2").attr("data-aos", "fade-in");
  


//   results.forEach((splitResult) => {
//     const wrappedLines = splitResult.lines
//       .map(
//         (wordsArr) => `
//         <span class="line"><div>
//           ${wordsArr
//             .map(
//               (word) => `${word.outerHTML}<span class="whitespace"> 
//          </span>`
//             )
//             .join("")}
//         </div></span>`
//       )
//       .join("");
//     splitResult.el.innerHTML = wrappedLines;
//   });

//   gsap.registerPlugin(ScrollTrigger);
//   let revealLines = revealText.forEach((element) => {
//     const lines = element.querySelectorAll(".line div");

//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: element,
//         start: "top 100%"
//       }
//     });
//     tl.set(lines, { autoAlpha: 1 });
//     tl.from(lines, 1.2, {
//       yPercent: 100,
//       ease: Power3.out,
//       stagger: 0.1,
//       delay: 0.1
//     });
//   });
// });











// home banner

window.addEventListener("load", function () {
  
  let revealText = document.querySelectorAll(".ls-home-banner .h1 ");
  let results = Splitting({ target: revealText, by: "lines" });
  jQuery(".ls-home-banner .h1 ,.section-shop-col2 h2").css("visibility", "visible");
//   jQuery(".section-shop-col2 h2").attr("data-aos", "fade-in");
  


  results.forEach((splitResult) => {
    const wrappedLines = splitResult.lines
      .map(
        (wordsArr) => `
        <span class="line"><div>
          ${wordsArr
            .map(
              (word) => `${word.outerHTML}<span class="whitespace"> 
         </span>`
            )
            .join("")}
        </div></span>`
      )
      .join("");
    splitResult.el.innerHTML = wrappedLines;
  });

  gsap.registerPlugin(ScrollTrigger);
  let revealLines = revealText.forEach((element) => {
    const lines = element.querySelectorAll(".line div");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 100%"
      }
    });
    tl.set(lines, { autoAlpha: 1 });
    tl.from(lines, 1, {
      yPercent: 100,
      ease: Power3.out,
      stagger: 0.1,
      delay: 0.4
    });
  });
});






window.addEventListener("load", function () {
  //let revealText = document.querySelectorAll(".reveal-text2,.ls-about-banner h1,.section-shop-col2 .block-shop-title .section-header h2");
  //let revealText = document.querySelectorAll(".reveal-text2,.index-section h2 .build-title, .ls-about-banner h1,.ls-section-leiter-s-offers h2, .block-shop-title .section-header h2,.ls-home-banner .h1, .ls-home-built-icon .h3 ,.about-program-section h2, .ls-feature-right h2, .ls-section-nationwide-delivery .h3");
  let revealText = document.querySelectorAll(".reveal-text2");
  let results = Splitting({ target: revealText, by: "lines" });

  results.forEach((splitResult) => {
    const wrappedLines = splitResult.lines
      .map(
        (wordsArr) => `
        <span class="line"><div>
          ${wordsArr
            .map(
              (word) => `${word.outerHTML}<span class="whitespace"> 
         </span>`
            )
            .join("")}
        </div></span>`
      )
      .join("");
    splitResult.el.innerHTML = wrappedLines;
  });
  
  //making the slided text visible - fixing an issue where the text didnt show up right
  
  //jQuery(".reveal-text2,.ls-about-banner h1,.ls-section-leiter-s-offers h2,.ls-home-banner .h1, .index-section h2 .build-title, .section-shop-col2 .block-shop-title .section-header h2, .about-program-section h2, .ls-feature-right h2, .ls-section-nationwide-delivery .h3").css("visibility", "visible");
  jQuery(".reveal-text2").css("visibility", "visible");

  gsap.registerPlugin(ScrollTrigger);
  let revealLines = revealText.forEach((element) => {
    const lines = element.querySelectorAll(".line div");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 100%"
      }
    });
    tl.set(lines, { autoAlpha: 1 });
    tl.from(lines, 1, {
      yPercent: 100,
      ease: Power3.out,
      stagger: 0.2,
      delay: 0.3
    });
  });
});

// $('.counter').each(function() {
//   var $this = $(this),
//       countTo = $this.attr('data-count');
  
//   $({ countNum: $this.text()}).animate({
//     countNum: countTo
//   },

//   {

//     duration: 8000,
//     easing:'linear',
//     step: function() {
//       $this.text(Math.floor(this.countNum));
//     },
//     complete: function() {
//       $this.text(this.countNum);
//     }

//   });  
  
// });


if ($(window).width()<960) {
$('.ls-feature--section .feature-row .feature-row__img-left .image-wrap,.ls-section-leiter-s-offers .feature-row .feature-row__item.feature-row__item-image .image-wrap,.ls-section-nationwide-delivery .image-wrap').attr('data-jarallax-element', '0')
}


(function($) {
    $.fn.countTo = function(options) {
        // merge the default plugin settings with the custom options
        options = $.extend({}, $.fn.countTo.defaults, options || {});

        // how many times to update the value, and how much to increment the value on each update
        var loops = Math.ceil(options.speed / options.refreshInterval),
            increment = (options.to - options.from) / loops;

        return $(this).each(function() {
            var _this = this,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);

            function updateTimer() {
                value += increment;
                loopCount++;
                $(_this).html(value.toFixed(options.decimals));

                if (typeof(options.onUpdate) == 'function') {
                    options.onUpdate.call(_this, value);
                }

                if (loopCount >= loops) {
                    clearInterval(interval);
                    value = options.to;

                    if (typeof(options.onComplete) == 'function') {
                        options.onComplete.call(_this, value);
                    }
                }
            }
        });
    };

    $.fn.countTo.defaults = {
        from: 0,  // the number the element should start at
        to: 100,  // the number the element should end at
        speed: 1000,  // how long it should take to count between the target numbers
        refreshInterval: 100,  // how often the element should be updated
        decimals: 0,  // the number of decimal places to show
        onUpdate: null,  // callback method for every time the element is updated,
        onComplete: null,  // callback method for when the element finishes updating
    };
})(jQuery);


//  $('.testimonials-slider').mouseover(function() {
//         $(this).slick('pause')
//     });
//     $('.testimonials-slider').mouseout(function() {
//         $(this).slick('play')
//     });


// ScrollTrigger.create({
//   trigger: ".grid__item--sidebar",
//   start: "top top",
//   end: "bottom bottom",
//   pin: true,
//   pinSpacing: false,
//   scrub: 1
// });
$('.testimonials-slider').marquee({
  duration: 10000,
  pauseOnHover: true,
  gap: 0,
  duplicated: true
});
$("body").on("click",".how-it-works-custom .slick-dots .slick-slide",function(){
   $(".how-it-works-custom .slick-dots .slick-slide").removeClass('slick-current');
   $(this).addClass('slick-current');
});